const possibleTypes = {
  Page: ['Page'],
};

export default possibleTypes;
